//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapGetters, mapState, mapActions } from 'vuex';
import messageBar from '../message/message-bar.vue';
import search from './search';
import * as types from '@/types';

function debounce(func) {
  let timer = null;
  return function () {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      func.call(this);
      timer = null;
    }, 300);
  };
}

export default {
  components: {
    search,
    messageBar,
  },
  data() {
    return {
      topLinks: [
        {
          name: 'top-links.official.title',
          value: 'top-links.official.glh.desc',
          logo: '',
          link: '/official',
        },
        {
          name: 'top-links.glh.title',
          value: 'top-links.glh.desc',
          logo: 'https://cdn.gelonghui.com/static/web/glhapp.png',
        },
        {
          name: 'top-links.zgb.title',
          value: 'top-links.zgb.desc',
          logo: 'https://cdn.gelonghui.com/static/web/zgbapp.png',
        },
        {
          name: 'top-links.hly.title',
          value: 'top-links.hly.desc',
          logo: 'https://cdn.gelonghui.com/static/web/roadshowapp.png',
        },
        {
          name: 'top-links.join-us.title',
          value: 'top-links.join-us.desc',
          logo: '',
          link: 'http://www.gelonghui.com/recruit',
        },
      ],
      navs: [
        {
          text: 'navs.home',
          url: '',
        },
        {
          text: 'navs.hotpost',
          url: 'hotpost',
        },
        {
          text: 'navs.live',
          url: 'live',
        },
        {
          text: 'navs.news',
          url: 'news',
        },
        {
          text: 'navs.subject',
          url: 'subject',
        },
        {
          text: 'navs.column',
          url: 'column',
        },
        {
          text: 'navs.market',
          url: 'market',
        },
        {
          text: 'navs.member-column',
          url: 'member',
        },
      ],
      userMenu: [
        {
          text: 'user.my-index',
          onClick: () => {
            this.$router.push(`/user/${this.userId}`);
          },
        },
        {
          text: 'user.my-portfolio',
          onClick: () => {
            this.$router.push(`/user/${this.userId}?type=portfolio`);
          },
        },
        {
          text: 'user.my-article',
          onClick: () => {
            this.$router.push('/my/publish');
          },
        },
        {
          text: 'user.my-favorite',
          onClick: () => {
            this.$router.push('/my/favorite');
          },
        },
        {
          text: 'user.my-purchase',
          onClick: () => {
            this.$router.push('/my/purchase');
          },
        },
        {
          text: 'user.setting',
          onClick: () => {
            this.$router.push('/my/setting');
          },
        },
        {
          text: 'user.logout',
          onClick: () => this.logout(),
        },
      ],
      isH1: true,
      itemShow: '',
      isChangingLang: false,
      showBar: false,
    };
  },

  computed: {
    ...mapGetters('user', [
      'isLogin',
      'avatar',
      'roleList',
      'vipInfo',
      'vipMemberInfo',
      'userId',
      'loginInfo',
    ]),
    ...mapState(['locale', 'advertisement']),
    /**
     * @description 获取当前访问路由
     * @returns { string } 当前路由状态
     */
    isRouteActive() {
      const path = this.$route.path;
      if (path.replace(/^\/zh-hk/, '') === '/member/infoSwiper') {
        return 'member/infoSwiper';
      }
      const arr = path.replace(/^\/zh-hk/, '').split('/');
      return arr[1];
    },
    /**
     * @description 导航栏广告对象
     * @returns { Object } 广告详情
     */
    adObj() {
      return (this.advertisement && this.advertisement.navbar) || null;
    },
    /**
     * @description 背景色
     */
    baseStyle() {
      let obj = null;
      if (this.adNavBg && this.isIndex) {
        obj = {
          background: this.adNavBg.backgroundColor,
        };
      }
      return obj;
    },
    /**
     * @description 导航栏节日背景
     */
    adNavBg() {
      return (this.advertisement && this.advertisement.adNavBg) || null;
    },
    /**
     * @description 判断会员是否过期
     * @returns { Boolean } 判断结果
     */
    isExpireDay() {
      const newDay = new Date();
      return this.vipMemberInfo.expireTimestamp * 1000 < newDay.getTime();
    },
    /**
     * @description 判断当前页面是不是首页
     * @returns { Boolean } 判断结果
     */
    isIndex() {
      return (
        (this.$route && ['/', '/zh-hk/'].includes(this.$route.path)) ||
        this.$route.path.includes('/tag/')
      );
    },
    unCheck() {
      let num = 0;
      if (this.loginInfo) {
        const { unCheck } = this.loginInfo.message;
        num = unCheck > 99 ? '99+' : unCheck;
      }
      return num;
    },
  },
  watch: {
    locale() {
      this.isChangingLang = false;
    },
    $route() {
      if (
        this.$route.name === 'news-id' ||
        this.$route.name === 'p-id' ||
        this.$route.name === 'live-id'
      ) {
        this.isH1 = false;
      }
      this.showBar = false;
    },
  },
  created() {
    if (
      this.$route.name === 'news-id' ||
      this.$route.name === 'p-id' ||
      this.$route.name === 'live-id'
    ) {
      this.isH1 = false;
    }
    // 路由判断
    if (
      this.$route.path === '/' ||
      this.$route.path === '/zh-hk' ||
      this.$route.path === '/zh-hk/'
    ) {
      this.itemShow = 'navs.home';
    } else if (this.$route.path.includes('/column')) {
      this.itemShow = 'navs.column';
    } else if (this.$route.path.includes('/news')) {
      this.itemShow = 'navs.news';
    } else if (this.$route.path.includes('/live')) {
      this.itemShow = 'navs.live';
    } else if (this.$route.path.includes('/subject')) {
      this.itemShow = 'navs.subject';
    } else if (this.$route.path.includes('/stock')) {
      this.itemShow = 'navs.stock';
    } else if (this.$route.path.includes('/market')) {
      this.itemShow = 'navs.market';
    } else {
      this.itemShow = 'navs.data';
    }
  },
  methods: {
    gotoCenter() {
      window.location.href = '/my/publish';
    },
    toArticle() {
      window.open(
        `/articleCreate/norpub.html?${Math.floor(Math.random() * 10)}`
      );
    },
    toHome() {
      window.location.href = '/myHome/commentMe';
    },
    toggleLang: debounce(function () {
      if (this.isChangingLang) {
        return;
      }
      this.isChangingLang = true;
      const loacle = this.$i18n.locale;
      switch (loacle) {
        case 'zh-cn':
          this.$i18n.setLocaleCookie('zh-hk');
          this.$i18n.setLocale('zh-hk');
          break;
        case 'zh-hk':
        default:
          this.$i18n.setLocaleCookie('zh-cn');
          this.$i18n.setLocale('zh-cn');
          break;
      }
    }),
    selectSort(item) {
      this.itemShow = item;
    },
    ...mapMutations('user', {
      show: types.SHOW_LOGIN_FORM,
    }),
    ...mapActions('user', {
      logout: types.LOGOUT,
    }),
  },
};
